export default "__VITE_ASSET__CRooerl2__"